"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const NavLinkStyles = (0, _styles.makeStyles)({
  rootNavLink: {
    alignItems: 'center',
    color: 'inherit',
    display: 'flex',
    paddingRight: _theme.default.spacing(2)
  },
  linkIcon: {
    display: 'flex',
    fontSize: _theme.default.typography.pxToRem(16),
    marginRight: '10px'
  }
});
var _default = exports.default = NavLinkStyles;